// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'phone-hangup-solid';

export const Component = () => (
  <path d='M0 15.663v-2.155c0-1.245.431-2.3 1.34-3.161.72-.719 1.533-1.15 2.347-1.293A49.931 49.931 0 0 1 12.213 8a46.76 46.76 0 0 1 8.237 1.005c1.102.192 1.963.623 2.634 1.293.862.862 1.293 1.916 1.293 3.209v2.155c0 .432-.143.767-.382 1.006-.336.239-.623.383-.958.335l-3.592.048c-.383 0-.72-.144-.958-.431a1.18 1.18 0 0 1-.432-.91v-1.581c0-.191-.096-.383-.239-.623-.143-.143-.287-.239-.43-.239-1.677-.431-3.4-.719-5.173-.766a25.12 25.12 0 0 0-5.077.67c-.288.096-.479.192-.527.335a.773.773 0 0 0-.287.623v1.58c0 .336-.144.623-.431.91-.24.288-.527.432-.91.432l-3.64-.048c-.336.048-.623-.048-.958-.383A1.338 1.338 0 0 1 0 15.662v.001Z' />
);

export const viewBox = '0 0 25 25';
